export class ChildrenModel {
    entityCode: number;
    year: number;
    version: number;
  }
  